import React from "react";
import TallerMigracion from "../images/contenido/TALLER AMNISTIA3.jpg";
import AmadoEnco from "../images/contenido/10_Amado Enco.jpg";
import Universidades from "../images/contenido/Foto taller universidades pag 50 a 53_edited.jpg";
import Jaramillo from "../images/contenido/Foto Jaramillo1 pag 59_edited.jpg";
import Restrepo from "../images/contenido/Foto Ética3 pag 25_edited.jpg";
import UPAO from "../images/contenido/UPAO.jpg";
import Miguel from "../images/contenido/1_Taller descentralizado con el periodista Miguel Gutiérrez_FM.jpg";
import Wilber from "../images/contenido/2_Taller descentralizado con el periodista Wilber Huacasi en Moquegua.jpg";
import Tuesta from "../images/contenido/tuesta taller nacional.jpg";
import Mariella from "../images/contenido/FM CONFLICTOS SOCIOAMBIENTALES 2-SDARC-11565532.jpg";
import David from "../images/contenido/FM CONFLICTOS SOCIOAMBIENTALES 1-SDARC-11565545.jpg";

import RestrepoLibro from "../images/contenido/6_portada libro Javier Darío Restrepo.jpg";
import TallerEtica from "../images/contenido/TALLER ETICA.jpg";
import Fermin from "../images/contenido/FerminKoop.jpg";
import Fowks from "../images/contenido/8_Jacqueline Fowks en taller con periodistas del Grupo La República Publicaciones.jpg";
import Jesus from "../images/contenido/7_taller con Jesús Raymundo.jpg";
import DavidHidalgo from "../images/contenido/Reserva_Taller de verificación de datos con David Hidalgo.jpg";
import TallerUcayali from "../images/contenido/Taller Ucayali.jpg";
import PercyMedica from "../images/contenido/9_Percy Medina en taller electoral.jpg";
import TallerElectoral from "../images/contenido/TALLER FISCALIZACION ELECTORAL PUCALLPA.jpg";
import Manual from "../images/contenido/12_portada manual de verificación de datos de candidatos.jpg";
import EstudiantesManual from "../images/contenido/11_estudiantes de la universidad nacional de ucayali.jpg";
import TallerReglas from "../images/contenido/Taller reglas electorales.jpg";
import Cutivalu from "../images/contenido/15_cutivalu mapa interactivo_edited.jpg";
import MapaVigilancia from "../images/contenido/13_Mapa de vigilancia electoral.jpg";
import Elecciones2021 from "../images/contenido/14_Vigilancia electoral 2021_edited.jpg";
import FotoGrupalPucp from "../images/contenido/foto grupal en el campus de la PUCP_edited.jpg";
import FotoPucp1 from "../images/contenido/Foto de sesiones presenciales 1_edited.jpg";
import FotoPucp2 from "../images/contenido/Foto de sesiones presenciales 2_edited.jpg";
import FotoGrupalMicaelas from "../images/contenido/Foto de la conformacio╠ün de la red en Cusco_edited.jpg";
import LogoMicaelas from "../images/contenido/Logo Micaelas_edited.jpg";
import SitioWebMicaelas from "../images/contenido/captura de pantalla de la web micaelas_edited.jpg";
import VocesDelSur from "../images/contenido/voces del sur_edited.jpg";
import TallerMovilizacion from "../images/contenido/TallerMovilizacionHumana.jpg";
import JoeParkin from "../images/contenido/JoeParkin.jpg";
import Anuska from "../images/contenido/Anuzka.jpg";
import TallerArequipa from "../images/contenido/TallerArequipa.jpg";
import ElizabethSalazar from "../images/contenido/19_elizabeth salazar.jpg";
import EpifanioBaca from "../images/contenido/EBaca.jpg";
import TallerPC from "../images/contenido/Reserva_Taller en Cusco con el Grupo Propuesta Ciudadana.jpg";
import WebExtractivas from "../images/contenido/20_industrias extractivas.jpg";
import TallerArequipa2018 from "../images/contenido/21_arequipa_edited.jpg";
import InfraestructuraNatural from "../images/contenido/22_portada infraestructura natural_edited.jpg";
import AguaInfraestructura from "../images/contenido/23_portada infraestructura natural_edited.jpg";
import HistoriasLucha from "../images/contenido/Historias de lucha.jpg";
import Cauces from "../images/contenido/Cauces de vida 2.jpg";
import ParticipantesSeguridad from "../images/contenido/Foto SPDA2 pag 40-41 Piura.jpg";
import TallerUniversidadUcayali from "../images/contenido/26_edmundo cruz y yovera en ucayali_edited.jpg";
import EstudiantesSanta from "../images/contenido/P43 Capacitación con estudiantes de la Universidad Nacional del Santa en Áncash_edited.jpg";
import EstudiantesUcayali from "../images/contenido/P43 Estudiantes de la Universidad Nacional de Ucayali en trabajo de campo_edited.jpg";
import EstudiantesPiura from "../images/contenido/P43 Taller de capacitación en la Universidad Nacional de Piura_edited.jpg";
import ReporterosNorte from "../images/contenido/Reporteros del norte_edited.jpg";
import WebVigilaPeru from "../images/contenido/28_vigila peru.jpg";

import Navigation from "../components/Navigation";
import { Fade } from "react-awesome-reveal";
import { Helmet } from "react-helmet";

const Talleres = () => {
  return (
    <section className="nosotros talleres">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Talleres sobre periodismo - Memoria 2014-2024 - Fundación Gustavo Mohme Llona</title>
        <meta
          property="og:title"
          content="Talleres sobre periodismo - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <Fade delay={100} triggerOnce>
              <div className="pre-title">2.1</div>
              <h1 className="color-blue">Talleres sobre periodismo</h1>
            </Fade>
          </div>
          <div className="column-0">
            <Fade delay={400} duration="2000" cascade triggerOnce>
              <div className="cont-mohme-0">
                <img
                  src={TallerMigracion}
                  alt="Taller Amnistia"
                  className="mohme-0"
                />
                <div className="legend">
                  Feline Freier trabaja con periodistas durante evento
                  organizado con Amnistía Internacional
                </div>
                <div className="block-blue"></div>
              </div>
              <div className="block-blue-light"></div>
            </Fade>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <Fade delay={0} triggerOnce damping={0.05} fraction={0} cascade>
              <p>
                Además de fundar <em>La República</em> el 16 de noviembre de
                1981, una decisión importante que adoptó Gustavo Mohme Llona en
                su trabajo como periodista fue la temprana creación de la Unidad
                de Investigación de este diario, el 15 de febrero de 1990. Lo
                decidido estuvo acompañado de la determinación de otorgar todas
                las facilidades al equipo periodístico y la libertad para
                realizar trabajos de investigación sobre cualquier tema de
                interés público, principalmente en el ámbito político. Esto
                permitió publicar una serie de importantes informes de
                investigación en escenarios políticos.
              </p>
              <p>
                La fundación busca prolongar este legado de apuesta firme por el
                periodismo de investigación a través del proyecto de talleres
                sobre periodismo y un conjunto de iniciativas afines. Desde su
                creación en el 2014, nuestra organización ha realizado múltiples
                capacitaciones (presenciales y a distancia) sobre periodismo de
                investigación, periodismo de datos y ética, además de sesiones
                temáticas en materia de derechos humanos, equidad de género y
                medio ambiente, en valiosa cooperación interinstitucional con
                organizaciones de la sociedad civil, entidades del Estado y
                universidades.
              </p>
              <div className="card">
                <div className="quote-blue">
                  <p>
                    Promovemos la ética y la calidad en el periodismo de
                    investigación como valores esenciales en la formación de
                    periodistas a nivel nacional.
                  </p>
                </div>
                <div>
                  <img
                    src={AmadoEnco}
                    alt="Amado Enco"
                    className="img-responsive"
                  />
                </div>
              </div>
              <div className="card-legend">
                <div className="legend">
                  Amado Enco, exprocurador anticorrupción, en charla sobre
                  vigilancia electoral
                </div>
              </div>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={Universidades}
                  alt="Periodistas en sesión de trabajo en Lima, durante taller sobre políticas electorales"
                  className=""
                />
                <div className="legend">
                  Periodistas en sesión de trabajo en Lima, durante taller sobre
                  políticas electorales
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={Jaramillo}
                  alt="Exposición de Mauricio Jaramillo, periodista colombiano y especialista en tecnología."
                  className=""
                />
                <div className="legend">
                  Exposición de Mauricio Jaramillo, periodista colombiano y
                  especialista en tecnología.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={Restrepo}
                  alt="Javier Darío Restrepo, Edmundo Cruz, Gustavo Gorriti, Úrsula Freundt-Thurne y Guillermo Nugent."
                  className=""
                />
                <div className="legend">
                  Javier Darío Restrepo, Edmundo Cruz, Gustavo Gorriti, Úrsula
                  Freundt-Thurne y Guillermo Nugent.
                </div>
              </figure>
              <h4>2.1.1 PERIODISMO DE INVESTIGACIÓN Y ÉTICA</h4>
              <p>
                Un eje fundamental de trabajo de la Fundación Gustavo Mohme
                Llona ha sido el fortalecimiento de capacidades de los
                periodistas para el trabajo de investigación en las regiones.
                Las materias estuvieron relacionadas, en general, con la
                fiscalización de los gobiernos regionales y locales, y también
                hubo intervenciones intensas en temporadas de elecciones.
              </p>
              <h5>A. Talleres itinerantes de periodismo de investigación</h5>
              <figure className="img-right img-m">
                <div className="block-blue-light"></div>
                <img
                  src={UPAO}
                  alt="Cierre de taller con Ángel Páez en la UPAO."
                  className="img-m"
                />
                <div className="legend">
                  Cierre de taller con Ángel Páez en la UPAO.
                </div>
              </figure>
              <figure className="img-right img-m">
                <div className="block-blue"></div>
                <img
                  src={Miguel}
                  alt="Taller descentralizado con el periodista Miguel Gutiérrez."
                  className="img-m"
                />
                <div className="legend">
                  Taller descentralizado con el periodista Miguel Gutiérrez.
                </div>
              </figure>
              <p>
                Desde la creación de la Fundación Gustavo Mohme Llona (2014),
                nos planteamos como primera estrategia de intervención el
                desarrollo de talleres formativos itinerantes, como una apuesta
                de fortalecimiento de las capacidades de quienes ejercen el
                periodismo en las distintas regiones del país. Desde esta etapa,
                tuvimos como aliado estratégico a la Asociación Nacional de
                Periodistas del Perú (ANP).
              </p>
              <p>
                Entre marzo del 2015 y julio del 2016, realizamos un total de 24
                talleres itinerantes de periodismo de investigación y periodismo
                de datos. Para tal fin, convocamos a periodistas especializados
                en investigación de <em>La República</em> y de otros medios
                aliados, quienes se desplazaron hacia las regiones para el
                dictado de estas capacitaciones. Todo esto en coordinación con
                la ANP. En este lapso de 17 meses, mediante las jornadas
                itinerantes, logramos capacitar a un total de 1 165 periodistas
                y estudiantes de Periodismo. Dada la coyuntura, estos talleres
                fueron, en general, sobre periodismo de investigación y
                periodismo de datos, con énfasis en fiscalización electoral.
              </p>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={Wilber}
                  alt="Taller descentralizado con el periodista Wilber Huacasi en Moquegua."
                  className=""
                />
                <div className="legend">
                  Taller descentralizado con el periodista Wilber Huacasi en
                  Moquegua.
                </div>
              </figure>
              <div className="table-content-talleres bg-blue-main">
                <p>
                  Las fechas y jurisdicciones donde se realizaron los talleres
                  en el año 2015 fueron:
                </p>
                <table>
                  <thead>
                    <th>FECHA</th>
                    <th>CIUDAD</th>
                    <th>EXPOSITOR</th>
                    <th>ASISTENTES</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>20 de marzo</td>
                      <td>Barranca</td>
                      <td>Ángel Páez</td>
                      <td>67</td>
                    </tr>
                    <tr>
                      <td>21 de marzo</td>
                      <td>Huaura</td>
                      <td>Ángel Páez</td>
                      <td>70</td>
                    </tr>
                    <tr>
                      <td>10 de abril</td>
                      <td>Chincha</td>
                      <td>Ángel Páez</td>
                      <td>36</td>
                    </tr>
                    <tr>
                      <td>11 de abril</td>
                      <td>Cañete</td>
                      <td>Ángel Páez</td>
                      <td>32</td>
                    </tr>
                    <tr>
                      <td>25 de abril</td>
                      <td>Tarapoto</td>
                      <td>Edmundo Cruz</td>
                      <td>22</td>
                    </tr>
                    <tr>
                      <td>16 de mayo</td>
                      <td>Iquitos</td>
                      <td>Miguel Gutiérrez</td>
                      <td>90</td>
                    </tr>
                    <tr>
                      <td>13 de junio</td>
                      <td>Huaraz</td>
                      <td>Daniel Yovera</td>
                      <td>60</td>
                    </tr>
                    <tr>
                      <td>4 de julio</td>
                      <td>Moquegua</td>
                      <td>Óscar Libón</td>
                      <td>54</td>
                    </tr>
                    <tr>
                      <td>11 de julio</td>
                      <td>Huaura</td>
                      <td>Edmundo Cruz</td>
                      <td>70</td>
                    </tr>
                    <tr>
                      <td>18 de julio</td>
                      <td>Pucallpa</td>
                      <td>Miguel Gutiérrez</td>
                      <td>40</td>
                    </tr>
                    <tr>
                      <td>18 de julio</td>
                      <td>Tumbes</td>
                      <td>Ángel Páez</td>
                      <td>62</td>
                    </tr>
                    <tr>
                      <td>28 de agosto</td>
                      <td>Callao</td>
                      <td>Edmundo Cruz</td>
                      <td>28</td>
                    </tr>
                    <tr>
                      <td>11 de setiembre</td>
                      <td>Jaén</td>
                      <td>Wilber Huacasi</td>
                      <td>38</td>
                    </tr>
                    <tr>
                      <td>3 de octubre</td>
                      <td>Huancayo</td>
                      <td>Edmundo Cruz</td>
                      <td>78</td>
                    </tr>
                    <tr>
                      <td>24 de octubre</td>
                      <td>Tingo María</td>
                      <td>Miguel Gutiérrez</td>
                      <td>40</td>
                    </tr>
                    <tr>
                      <td>29 de octubre</td>
                      <td>Lima</td>
                      <td>Óscar Castilla</td>
                      <td>42</td>
                    </tr>
                    <tr>
                      <td>5 de diciembre</td>
                      <td>Cajamarca</td>
                      <td>Nelly Luna</td>
                      <td>42</td>
                    </tr>
                    <tr>
                      <td>12 de diciembre</td>
                      <td>Chimbote</td>
                      <td>Miguel Gutiérrez</td>
                      <td>43</td>
                    </tr>
                    <tr>
                      <td>12 de diciembre</td>
                      <td>Moyobamba</td>
                      <td>Wilber Huacasi</td>
                      <td>30</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  Esta estrategia de intervención continuó en el año 2016 con
                  cinco talleres adicionales en las siguientes ciudades:
                </p>
                <table>
                  <thead>
                    <th>FECHA</th>
                    <th>CIUDAD</th>
                    <th>EXPOSITOR</th>
                    <th>ASISTENTES</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2 de abril</td>
                      <td>Cajamarca</td>
                      <td>Nelly Luna</td>
                      <td>6</td>
                    </tr>
                    <tr>
                      <td>23 de abril</td>
                      <td>Iquitos</td>
                      <td>Fabiola Torres</td>
                      <td>42</td>
                    </tr>
                    <tr>
                      <td>24 de mayo</td>
                      <td>Cusco</td>
                      <td>Edmundo Cruz</td>
                      <td>87</td>
                    </tr>
                    <tr>
                      <td>27 de mayo</td>
                      <td>Huaraz</td>
                      <td>Edmundo Cruz</td>
                      <td>61</td>
                    </tr>
                    <tr>
                      <td>9 de julio</td>
                      <td>Chiclayo</td>
                      <td>Ángel Páez y Fabiola Torres</td>
                      <td>25</td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  Estos viajes y el enfoque de trabajo descentralizado
                  permitieron a nuestra organización conocer también las
                  problemáticas locales y regionales, siendo la corrupción una
                  de las más constantes, situación que tuvo incidencia en las
                  siguientes decisiones para nuestra estrategia de intervención.
                </p>
              </div>
              <figure className="img-right img-m">
                <div className="block-blue-light"></div>
                <img
                  src={Tuesta}
                  alt="Fernando Tuesta en actualización sobre reglas electorales durante el primer taller nacional realizado en la UPC."
                  className="img-m"
                />
                <div className="legend">
                  Fernando Tuesta en actualización sobre reglas electorales
                  durante el primer taller nacional realizado en la UPC.
                </div>
              </figure>
              <h5>
                B. Talleres nacionales de periodismo de investigación (2016)
              </h5>
              <p>
                En el 2016, la Fundación Gustavo Mohme Llona también realizó dos
                talleres nacionales de periodismo de investigación en la ciudad
                de Lima. En este caso, la estrategia de intervención consistió
                en el lanzamiento de una convocatoria nacional de postulaciones
                para el acceso a becas de capacitación.
              </p>
              <p>
                En esta oportunidad establecimos valiosas alianzas con la
                Facultad de Comunicación y Periodismo de la Universidad Peruana
                de Ciencias Aplicadas (UPC), la carrera de Periodismo de la
                Universidad Antonio Ruiz de Montoya y la Fundación
                Friedrich-Ebert-Stiftung (FES).
              </p>
              <figure className="img-left img-m">
                <div className="block-blue"></div>
                <img
                  src={Mariella}
                  alt="Mariella Checa, de la Universidad Antonio Ruiz de Montoya, como facilitadora del segundo taller nacional."
                  className="img-m"
                />
                <div className="legend">
                  Mariella Checa, de la Universidad Antonio Ruiz de Montoya,
                  como facilitadora del segundo taller nacional.
                </div>
              </figure>
              <figure className="img-left img-m">
                <div className="block-blue-light"></div>
                <img
                  src={David}
                  alt="David Rivera expone durante el segundo taller nacional de periodismo."
                  className="img-m"
                />
                <div className="legend">
                  David Rivera expone durante el segundo taller nacional de
                  periodismo.
                </div>
              </figure>
              <p>
                El primer taller nacional se realizó los días 5 y 6 de febrero
                del 2016 en la sede de la UPC y contó con la participación de 30
                periodistas becados. El segundo taller se realizó el 30 de
                setiembre y el 1 de octubre del 2016 en Miraflores. En esta
                oportunidad se contó con 35 periodistas becados. Es decir, 65
                periodistas de regiones fueron beneficiados con estas becas
                integrales.
              </p>
              <p>
                En las jornadas se abordaron temas vinculados a las herramientas
                y estrategias para el trabajo de investigación en temporadas
                electorales, al periodismo de datos y a la actualización de las
                normas vigentes en materia electoral. En esta intervención se
                mantuvo la estrategia de trabajo descentralizado, y se buscó, al
                mismo tiempo, generar espacios de interacción entre los
                periodistas de distintas regiones, en jornadas de sesiones
                presenciales, con el fin de dinamizar nuevas iniciativas como el
                ejercicio de periodismo colaborativo o la constitución de redes.
              </p>
              <h4>2.1.3 PERIODISMO Y POLÍTICA</h4>

              <h5>
              A. Ciclo de Diálogos Políticos con Periodistas
              </h5>
              <figure className="img-right img-mohme-5">
                <div className="block-circle-blue"></div>
                <img
                  src={RestrepoLibro}
                  alt="Producto de esta jornada, la UPC publicó
                a fines del año 2017 el libro El futuro del
                periodismo, de Javier Darío Restrepo."
                  className="img-mohme-5"
                />
                <div className="legend">
                  Producto de esta jornada, la UPC publicó a fines del año 2017
                  el libro{" "}
                  <a href="https://repositorioacademico.upc.edu.pe/handle/10757/622211">
                    El futuro del periodismo
                  </a>
                  , de Javier Darío Restrepo.
                </div>
              </figure>
              <p>
                Otra actividad importante de formación para los periodistas de
                las regiones y de los medios nacionales fue el taller
                “Reflexiones periodísticas: medios de comunicación, ética y
                fuentes de financiamiento”, realizado en setiembre del 2017 en
                alianza con la carrera de Comunicaciones y Periodismo de la
                Universidad Peruana de Ciencias Aplicadas (UPC).
              </p>
              <p>
                Esta jornada tuvo como expositor conferencista a Javier Darío
                Restrepo, maestro en temas de ética de la Fundación para el
                Nuevo Periodismo Iberoamericano Gabriel García Márquez de
                Colombia.
              </p>
              <p>
                Javier Darío Restrepo ofreció una conferencia magistral titulada
                “El futuro del periodismo”. Esta charla sirvió como insumo
                inicial para el taller que contó con la participación de
                periodistas de Lima y regiones. En esta ocasión, la convocatoria
                se hizo a través de invitaciones directas a 40 periodistas que
                cumplen un rol decisorio en sus medios, principalmente editores.
                La metodología de trabajo fue plantear casos concretos sobre
                dilemas éticos a los que se enfrentan los periodistas y editores
                en el día a día. Luego, se generaron debates grupales para,
                finalmente, arribar a conclusiones presentadas en un plenario,
                contando con los comentarios finales del maestro colombiano
                Javier Darío Restrepo.
              </p>
              <figure className="img-left img-mohme-5">
                <div className="block-blue"></div>
                <img
                  src={TallerEtica}
                  alt="Periodista colombiano Javier Darío
                Restrepo en la sede San Isidro de la UPC."
                  className="img-mohme-5"
                />
                <div className="legend">
                  Periodista colombiano Javier Darío Restrepo en la sede San
                  Isidro de la UPC.
                </div>
              </figure>
              <p>
                Una de las principales reflexiones para el periodismo que dejó
                Javier Darío Restrepo en esta jornada fue que la clave del
                futuro está determinada por la tecnología digital, pero subrayó
                que “esa clave está condicionada por los ideales éticos de la
                profesión que le dan consistencia y valor a la tecnología”.
              </p>
              <p>
                Sobre el ideal ético de la información periodística, Restrepo
                apuntó tres aspectos que representan el contenido de este ideal:
                “compromiso con la verdad, independencia y responsabilidad con
                la sociedad”.
              </p>
              <div className="clear"></div>
              <h5>
                D. Talleres de capacitación para periodistas de{" "}
                <em>La República</em>
              </h5>
              <figure className="img-right img-mohme-5">
                <div className="block-circle-blue"></div>
                <img
                  src={Fermin}
                  alt="Conferencia virtual de Fermín Koop
                en marzo del 2022."
                  className="img-mohme-5"
                />
                <div className="legend">
                  Conferencia virtual de Fermín Koop en marzo del 2022.
                </div>
              </figure>
              <p>
                La Fundación Gustavo Mohme Llona, al ser una institución
                directamente vinculada con la familia de periodistas del Grupo
                La República Publicaciones, ha realizado también talleres
                presenciales exclusivos de capacitación para los equipos de
                redacción de <em>La República</em>, <em>El Popular</em>,{" "}
                <em>Wapa</em> y <em>Líbero</em>, principalmente durante el año
                2019.
              </p>
              <p>
                Las materias dictadas fueron de actualización en redacción, con
                el periodista Jesús Raymundo; rigurosidad en el proceso del
                tratamiento de la información, con Jacqueline Fowks
                (corresponsal de <em>El País</em>); verificación de noticias
                falsas, con David Hidalgo (Ojo Público); y técnicas de
                entrevista, con Emilio Camacho (editor del suplemento Domingo de{" "}
                <em>La República</em>).
              </p>
              <p>
                En el 2022, nuestra organización ha retomado esta apuesta de
                fortalecimiento de las capacidades en la familia del Grupo La
                República Publicaciones. Inició con un taller virtual sobre
                Periodismo y Cambio Climático, que contó con la participación
                como expositor del periodista argentino Fermín Koop.
              </p>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={Fowks}
                  alt="Jacqueline Fowks en jornada de trabajo sobre la rigurosidad periodística."
                  className=""
                />
                <div className="legend">
                  Jacqueline Fowks en jornada de trabajo sobre la rigurosidad
                  periodística.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={Jesus}
                  alt="Jesús Raymundo, en taller sobre escritura periodística."
                  className=""
                />
                <div className="legend">
                  Jesús Raymundo, en taller sobre escritura periodística.
                </div>
              </figure>
              <div className="quote quote-center quote-blue">
                <p>
                  Para la Fundación Gustavo Mohme Llona, las capacitaciones
                  deben ser una constante en el periodismo, tanto en el aspecto
                  técnico como en la especialización sobre los contenidos.
                </p>
              </div>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={DavidHidalgo}
                  alt="Periodista David Hidalgo comparte herramientas para la verificación de noticias falsas."
                  className=""
                />
                <div className="legend">
                  Periodista David Hidalgo comparte herramientas para la
                  verificación de noticias falsas.
                </div>
              </figure>
              <h4>
                2.1.2 FORTALECIMIENTO DE LA DEMOCRACIA EN CONTEXTOS ELECTORALES
              </h4>
              <p>
                Luego de la experiencia de los talleres itinerantes y los
                talleres nacionales, y a partir del conocimiento sobre los
                problemas locales y regionales identificados, la Fundación
                Gustavo Mohme Llona optó por orientar su estrategia de
                intervención hacia el fortalecimiento de capacidades para la
                fiscalización electoral. Esto debido al alto índice de
                autoridades regionales y locales con investigaciones abiertas
                por presuntos delitos asociados a la corrupción, según
                información compartida por el Ministerio Público y la
                Procuraduría Nacional Anticorrupción.
              </p>

              <p>
                A partir de este diagnóstico, la fundación impulsó talleres
                descentralizados y macrorregionales de periodismo de
                investigación, principalmente para fiscalizar las jornadas
                electorales, pues las actividades coincidieron con las
                elecciones nacionales del 2016 y las elecciones regionales y
                municipales del 2018. Esto en un contexto de constantes
                intentos, desde la Comisión de Constitución del Congreso, para
                la modificación de las reglas de juego, en lo que se conoció
                como la “contrarreforma electoral”.
              </p>

              <h5>
                A. Talleres sobre vigilancia electoral con IDEA Internacional
                (2018)
              </h5>
              <figure className="img-right img-m">
                <div className="block-blue"></div>
                <img
                  src={TallerUcayali}
                  alt="Periodistas y comunicadores de Ucayali, en jornada de trabajo sobre elecciones."
                  className="img-m"
                />
                <div className="legend">
                  Periodistas y comunicadores de Ucayali, en jornada de trabajo
                  sobre elecciones.
                </div>
              </figure>
              <p>
                Para esta etapa iniciamos un trabajo en alianza con la
                organización IDEA Internacional, a través del Proyecto
                Ciudadanos Comprometidos con unas Elecciones Limpias. Si bien la
                propuesta del proyecto era realizar cinco talleres regionales,
                sobre la marcha hubo requerimientos de otras regiones para
                replicar las jornadas de intervención, razón por la cual al
                final terminamos con ocho talleres en las siguientes
                jurisdicciones:
              </p>
              <ul>
                <li>
                  Callao (con invitación al equipo de corresponsales regionales
                  del portal aliado Ojo Público)
                </li>
                <li>
                  Huánuco (con participación de periodistas de Tingo María)
                </li>
                <li>Pucallpa (Ucayali)</li>
                <li>Huamanga (Ayacucho)</li>
                <li>Chimbote (Áncash)</li>
                <li>Piura (con participación de periodistas de Chiclayo)</li>
                <li>Cusco (con participación de periodistas de Apurímac)</li>
                <li>Cerro de Pasco</li>
              </ul>
              <p>
                Como se puede apreciar, algunos talleres tuvieron una
                connotación macrorregional, con lo cual llegamos, en realidad, a
                periodistas de un total de diez regiones. Esto, en el marco de
                nuestra convicción de seguir generando oportunidades a
                periodistas que no pueden acceder con mucha facilidad a cursos
                especializados de capacitación.
              </p>
              <div className="quote quote-center quote-blue">
                <p>
                  Además de las capacitaciones en materia electoral, la
                  Fundación Gustavo Mohme Llona ha facilitado procesos para el
                  diseño de propuestas que fortalecen la transparencia.
                </p>
              </div>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={PercyMedica}
                  alt="Percy Medina, de IDEA Internacional, en taller con periodistas de Huánuco."
                  className=""
                />
                <div className="legend">
                  Percy Medina, de IDEA Internacional, en taller con periodistas
                  de Huánuco.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={TallerElectoral}
                  alt="Cierre de taller en la Universidad Nacional de Ucayali."
                  className=""
                />
                <div className="legend">
                  Cierre de taller en la Universidad Nacional de Ucayali.
                </div>
              </figure>
              <h5>
                <em>Un manual para la fiscalización electoral</em>
              </h5>
              <figure className="img-right img-mohme-5">
                <div className="block-blue-light"></div>
                <img
                  src={Manual}
                  alt="Portada del Manual de verificación de datos de candidatos"
                  className="img-mohme-5"
                />
                <div className="legend">
                  Portada del{" "}
                  <a
                    href="https://fundacionmohme.org/wp-content/
uploads/2021/02/MANUAL-VIGILANCIAACTUALIZADO-
2021_min.pdf"
                  >
                    Manual de verificación de datos de candidatos.
                  </a>
                </div>
              </figure>
              <p>
                La intervención, en alianza con IDEA Internacional, también nos
                permitió avanzar con la producción de materiales específicos
                para los periodistas, situación que cobra relevancia si se tiene
                en cuenta que son escasos los materiales o manuales
                sistematizados para el trabajo de investigación.
              </p>

              <p>
                El Manual de verificación de datos de candidatos fue elaborado
                por el periodista Ángel Páez, jefe de la Unidad de Investigación
                de La República. Se terminó de imprimir en diciembre del 2019 y
                fue distribuido entre periodistas de regiones. Además, se
                compartieron ejemplares con las universidades públicas que
                cuentan con las carreras profesionales de Periodismo o Ciencias
                de la Comunicación.
              </p>
              <p>
                En el contexto de estos talleres, la Fundación Gustavo Mohme
                Llona también auspició el libro de perfiles de candidatos de la
                región Puno, del periodista de <em>La República</em> Liubomir
                Fernández Fernández, Folklore político: perfil de candidatos al
                Gobierno Regional de Puno (2018).
              </p>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={EstudiantesManual}
                  alt="Estudiantes de periodismo de la Universidad Nacional de Ucayali
                conocen las herramientas disponibles para investigar candidatos."
                  className=""
                />
                <div className="legend">
                  Estudiantes de periodismo de la Universidad Nacional de
                  Ucayali conocen las herramientas disponibles para investigar
                  candidatos.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={TallerReglas}
                  alt="Allan Wagner, Pilar Tello, Clara Elvira Ospina y Avelino Guillén"
                  className=""
                />
                <div className="legend">
                  Allan Wagner, Pilar Tello, Clara Elvira Ospina y Avelino
                  Guillén en el taller nacional para la revisión de las reglas
                  electorales y la formulación de propuestas sobre
                  transparencia.
                </div>
              </figure>
              <h5>
                <em>Enfoque de políticas públicas</em>
              </h5>
              <p>
                El trabajo con IDEA Internacional terminó con una sesión
                presencial con periodistas previamente seleccionados por
                invitación en la ciudad de Lima (taller “Reforma política:
                transparencia y acceso a la información electoral desde la
                mirada del periodismo de investigación”). Además de sostener
                capacitaciones, esta sesión realizada en febrero del 2019
                permitió desarrollar una estrategia de trabajo desde el enfoque
                de las políticas públicas.
              </p>
              <p>
                En las sesiones de trabajo y con el acompañamiento de la
                Fundación Gustavo Mohme Llona, los periodistas identificaron los
                problemas públicos en materia de transparencia y acceso a la
                información pública que impiden o bloquean la fiscalización
                periodística. A partir de ello, se identificaron diez propuestas
                de modificaciones normativas en materia de transparencia, las
                mismas que fueron presentadas y sometidas al debate público, a
                través de nuestra web institucional, y que se encuentran a
                disposición de la ciudadanía y la clase política para el debate
                y la eventual aprobación.
              </p>
              <p>
                Participaron en esta iniciativa periodistas del Grupo La
                Industria (Áncash), diario <em>Página 3</em> (Huánuco), Radio
                Altura (Pasco), Prensa Chalaca (Callao), Radio Central
                (Apurímac), El Búho (Arequipa),
                <em>Correo</em> (corresponsal de Ayacucho), <em>El Comercio</em>{" "}
                (corresponsal de Piura) y periodistas de Ojo Público, Convoca,
                Wayka y <em>La República</em>. Las propuestas formuladas se
                pueden conocer en las siguientes páginas.
              </p>
              <div className="table-content-talleres bg-blue-main table-propuestas">
                <table>
                  <thead>
                    <th>PROBLEMA IDENTIFICADO</th>
                    <th>PROPUESTA DE REFORMA</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Falta de acceso oportuno a la información sobre los
                        ingresos y gastos de campaña de las organizaciones
                        políticas.
                      </td>
                      <td>
                        Modificación del art. 34.6 de la Ley de Organizaciones
                        Políticas (ley N.° 28094) para la entrega de un reporte
                        mensual durante la campaña.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Información insuficiente en las hojas de vida de los
                        candidatos, respecto de las investigaciones en curso en
                        el ámbito del Ministerio Público y en los órganos de
                        control del sector público.
                      </td>
                      <td>
                        Modificación del art. 23.3 de la Ley de Organizaciones
                        Políticas (ley N.° 28094) para que los candidatos
                        consignen en su hoja de vida todas las investigaciones
                        preliminares o preparatorias que tienen en curso en el
                        Ministerio Público y en los órganos de control interno
                        del sector público, bajo sanción de exclusión en caso de
                        omisión.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Los candidatos no incluyen todas las sentencias en las
                        hojas de vida para los casos en los que ya han cumplido
                        la condena, bajo el criterio de que han adquirido la
                        condición de rehabilitado.
                      </td>
                      <td>
                        Modificación del art. 23.3 de la Ley de Organizaciones
                        Políticas (ley N.° 28094), para que los candidatos
                        consignen en su hoja de vida todas las sentencias
                        dictadas en su contra, incluidas aquellas en las que ya
                        han cumplido la condena, bajo sanción de exclusión en
                        caso de omisión.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Información insuficiente en las hojas de vida de los
                        candidatos, respecto de su entorno familiar, político,
                        empresarial o societaria.
                      </td>
                      <td>
                        Modificación del art. 23.3 de la Ley de Organizaciones
                        Políticas (ley N.° 28094) para que los candidatos
                        consignen adicionalmente en su hoja de vida la
                        Declaración Jurada de Intereses, con información sobre
                        el entorno familiar en primer grado de consanguinidad;
                        lista de las personas que forman parte del equipo de
                        campaña; participación en empresas u otro tipo de
                        organizaciones con personería jurídica durante los
                        últimos cinco años; participación en organizaciones
                        políticas en los últimos cinco años; empleos, asesorías,
                        consultorías u otros servicios similares en los últimos
                        cinco años.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Restricción para el acceso libre a información sobre los
                        antecedentes de los candidatos que obra en la Ventanilla
                        Única del Jurado Nacional de Elecciones.
                      </td>
                      <td>
                        Modificación del art. 4 de la Ley que crea la Ventanilla
                        Única de Antecedentes para Uso Electoral (ley N.° 30322)
                        para contemplar el acceso libre a la información de la
                        Ventanilla Única durante el periodo electoral.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Barrera económica y digital para el acceso a los
                        certificados de movimiento migratorio en la
                        Superintendencia Nacional Migraciones del Ministerio del
                        Interior (costo actual: S/20.10).
                      </td>
                      <td>
                        Modificación del TUPA de la Superintendencia Nacional de
                        Migraciones, equiparando el costo para el acceso a los
                        certificados de movimiento migratorio con el costo
                        regulado para el acceso a la información pública e
                        implementación de herramientas digitales para el acceso
                        inmediato a la información.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Barrera económica para el acceso a información sobre las
                        propiedades de los candidatos en la Superintendencia
                        Nacional de Registros Públicos (costo actual por imagen
                        en formato electrónico: S/5.00).
                      </td>
                      <td>
                        Modificación del TUPA de Superintendencia Nacional de
                        Registros Públicos, regulando los costos para el acceso
                        a información sobre las propiedades de todas las
                        personas en el mismo rubro para el acceso a la
                        información pública.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Falta de integración y mayor apertura de las plataformas
                        de datos abiertos del Jurado Nacional de Elecciones
                        (Infogob y Plataforma Electoral).
                      </td>
                      <td>
                        Modificación del art. 5 de la Ley Orgánica del Jurado
                        Nacional de Elecciones (ley N.° 26486), incluido un
                        inciso sobre las funciones del JNE, regulando la
                        obligatoriedad para la gestión de una base de datos
                        integrada y la obligatoriedad para que los datos
                        abiertos puedan ser descargados de manera íntegra.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Falta de integración y mayor apertura de las plataformas
                        de datos abiertos de la ONPE en materia de
                        financiamiento público y privado de las organizaciones
                        políticas (claridad y sección “Supervisión del
                        Financiamiento de Organizaciones Políticas”).
                      </td>
                      <td>
                        Modificación del art. 5 de la Ley Orgánica de la Oficina
                        Nacional de Procesos Electorales (ley N.° 26487),
                        incluido un inciso sobre las funciones de la ONPE,
                        regulando la obligatoriedad para la gestión de una base
                        de datos integrada y la obligatoriedad para que los
                        datos abiertos puedan ser descargados de manera íntegra.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Falta de actualización oportuna de los portales de
                        transparencia estándar en las instituciones del Estado
                        en los tres niveles de gobierno, en materia de
                        información presupuestal (planillas, y contrataciones de
                        bienes y servicios) y registro de visitas.
                      </td>
                      <td>
                        Modificación del art. 6 de la Ley de Transparencia y
                        Acceso a la Información Pública (ley N.° 27806) para que
                        las entidades del gobierno central y los gobiernos
                        regionales y municipales actualicen los portales de
                        transparencia estándar máximo al mes de haberse iniciado
                        la nueva gestión, y para los meses siguientes las
                        planillas y toda la información sobre contrataciones de
                        bienes y servicios, además del registro de visitas que
                        deben ser publicadas de forma simultánea con la
                        realización del acto administrativo correspondiente,
                        bajo responsabilidad.
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  <a href="https://fundacionmohme.org/diez-propuestas-para-fortalecer-la-vigilancia-electoral/">
                    https://fundacionmohme.org/diez-propuestas-para-fortalecer-la-vigilancia-electoral/
                  </a>
                </p>
              </div>
              <p>
                La agenda de corto plazo del Congreso y de la Comisión de
                Constitución, al impulsar reformas pensando únicamente en las
                elecciones cercanas, impidió avanzar con estas propuestas de
                reformas de fondo sobre el fortalecimiento de la transparencia
                para la fiscalización electoral. Sin embargo, las mismas se
                mantienen vigentes para el debate público y político.
              </p>
              <h5>B. Herramientas digitales para la vigilancia electoral</h5>
              <p>
                Además de las capacitaciones y el diseño del manual para la
                investigación de los datos de los candidatos, la Fundación
                Gustavo Mohme Llona generó herramientas digitales interactivas
                para la vigilancia electoral.
              </p>
              <figure className="img-right img-m">
                <div className="block-blue-light"></div>
                <img
                  src={Cutivalu}
                  alt="Portal web de Radio Cutivalú de Piura"
                  className="img-m border-img"
                />
                <div className="legend">
                  Portal web de Radio Cutivalú de Piura, con la herramienta
                  virtual elaborada por el Proyecto Talleres de Periodismo.
                </div>
              </figure>
              <p>
                En el 2020, en el marco de las elecciones congresales
                complementarias, habilitamos en la web institucional el “Mapa de
                vigilancia electoral”, una herramienta interactiva para que los
                periodistas y la ciudadanía en general puedan identificar qué
                candidatos de sus regiones reportaban sentencias penales,
                sentencias por violencia familiar o candidatos que enfrentaron
                demandas civiles por alimentos. Todo esto, con información de
                las hojas de vida de los candidatos.
              </p>
              <p>
                El desarrollo de esta herramienta contó con la participación de
                estudiantes de la Universidad Nacional de Piura, la Universidad
                Nacional de Pucallpa y la Universidad Nacional de San Antonio
                Abad de Cusco, en el marco de otra iniciativa que veremos más
                adelante.
              </p>
              <p>
                En el año 2021, la fundación también habilitó un mapa
                interactivo, durante las elecciones generales, a fin de que la
                ciudadanía pueda encontrar información en tres rubros:
                candidatos que reportan sentencias penales o fallos por demandas
                civiles; candidatos que participaron en otras elecciones y no
                cumplieron con entregar sus informes de ingresos y gastos de
                campaña; y candidatos que al momento de postular reportaban
                investigaciones fiscales en curso por presuntos delitos
                vinculados con la corrupción.
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={MapaVigilancia}
                  alt="Mapa de vigilancia electoral"
                  className="border-img"
                />
                <div className="legend">
                  El desarrollo de esta herramienta contó con la participación
                  de estudiantes de la Universidad Nacional de Piura, la
                  Universidad Nacional de Pucallpa y la Universidad Nacional de
                  San Antonio Abad de Cusco. La herramienta está disponible{" "}
                  <a href="https://fundacionmohme.org/especiales/vigilancia-electoral-2021">
                    aquí
                  </a>
                  .
                </div>
              </figure>
              <div className="quote quote-center quote-blue">
                <p>
                  Estas herramientas están alojadas en el sitio web de nuestra
                  organización y fueron compartidas por medios digitales de las
                  regiones.
                </p>
              </div>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={Elecciones2021}
                  alt="Mapa de vigilancia electoral 2021"
                  className="border-img"
                />
                <div className="legend">
                  Herramienta para la verificación de las sentencias,
                  investigaciones por corrupción en curso y omisiones sobre
                  financiamiento de campaña. La herramienta se puede consultar{" "}
                  <a href="https://fundacionmohme.org/especiales/vigilancia-electoral-2021">
                    aquí
                  </a>
                  .
                </div>
              </figure>
              <h5>
                C. Incidencia para el fortalecimiento de la transparencia en la
                ONPE
              </h5>
              <p>
                Finalmente, en concordancia con nuestra estrategia de
                intervención, desde un enfoque de políticas públicas o
                incidencia en las entidades del Estado para generar cambios en
                favor del fortalecimiento de la transparencia, la Fundación
                Gustavo Mohme Llona organizó dos sesiones de trabajo con
                periodistas de regiones para desarrollar propuestas de mejora de
                la{" "}
                <a href="https://www.web.onpe.gob.pe/claridadCiudadano2/">
                  plataforma Claridad
                </a>
                .
              </p>
              <p>
                Los días 7 y 9 de abril del 2021, participaron en estas sesiones
                periodistas de Radio Cutivalú (Piura), El Búho (Arequipa), Radio
                Estación Wari (Ayacucho), Canal 45 (Cajamarca), Prensa Chalaca
                (Callao), <em>Correo</em> (Arequipa), Wayka (Lima) y los
                corresponsales de RPP de La Libertad, Pasco y Junín. Tras estos
                encuentros, la Fundación Gustavo Mohme Llona sistematizó las
                propuestas y las remitió a través de una carta al titular de la
                ONPE, Piero Corvetto, en mayo del 2021. En resumen, las
                observaciones detectadas y las propuestas formuladas al respecto
                fueron las siguientes:
              </p>
              <div className="table-content-talleres bg-blue-main table-propuestas">
                <table>
                  <tbody>
                    <tr>
                      <td>1. Demora en el levantamiento de información.</td>
                      <td>
                        A pesar de los plazos vencidos, los periodistas no
                        lograron acceder a la información completa y actualizada
                        de forma inmediata sobre las rendiciones de ingresos y
                        gastos de los candidatos, lo cual debilita la vigilancia
                        en tiempo real. Se recomendó a la ONPE “adoptar los
                        mecanismos internos necesarios en términos de
                        reglamentación o presupuesto, con el propósito de
                        optimizar el proceso de levantamiento de información a
                        fin de que el periodismo y la ciudadanía accedan a ella
                        de manera oportuna”.
                      </td>
                    </tr>
                    <tr>
                      <td>2. Falta diferenciar a los candidatos excluidos.</td>
                      <td>
                        Otro aspecto detectado fue que la plataforma Claridad
                        incluía a los postulantes que fueron excluidos del
                        proceso. De un total de 1 424 candidatos que
                        supuestamente no cumplieron con presentar sus informes
                        ante la plataforma Claridad, 417 no lo hicieron porque
                        ya estaban retirados del proceso. Pero en Claridad sus
                        nombres aparecían en rojo, como si no hubieran cumplido
                        con presentar la documentación, cuando en realidad ya no
                        estaban obligados. En este punto se recomendó a la ONPE
                        “establecer mecanismos de coordinación con el Jurado
                        Nacional de Elecciones (JNE), a fin de cruzar
                        información de manera oportuna sobre los candidatos
                        retirados del proceso y dejar constancia de ello en los
                        resultados de búsqueda”. A la fecha, se ha verificado
                        que los excluidos ya no aparecen en la plataforma
                        Claridad.
                      </td>
                    </tr>
                    <tr>
                      <td>3. Imprecisiones en la información.</td>
                      <td>
                        Los periodistas también detectaron casos concretos de
                        discordancia respecto de la información que aparece en
                        el sistema de búsqueda y los PDF que entregaron los
                        candidatos. Es decir, información o documentación de
                        algunos candidatos aparecían en los enlaces de otros.
                        Por ello se recomendó a la ONPE “afinar sus
                        procedimientos internos a fin de evitar confusiones en
                        la ciudadanía respecto de estos casos concretos”.
                      </td>
                    </tr>
                    <tr>
                      <td>4. Información incorrecta.</td>
                      <td>
                        Los periodistas también detectaron casos concretos de
                        postulantes de anteriores procesos electorales que sí
                        cumplieron con entregar sus informes, pero en Claridad
                        aparecían como si no lo hubieran hecho. Se recomendó a
                        la ONPE “perfeccionar los procedimientos internos a fin
                        de evitar inducción a error a la ciudadanía”.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        5. Información incompleta en los archivos adjuntos.
                      </td>
                      <td>
                        Los periodistas también identificaron documentos
                        escaneados en forma recortada o archivos PDF con
                        información borrosa e ilegible. Se propuso a la ONPE
                        “reglamentar procedimientos que permitan optimizar la
                        entrega de los archivos adjuntos (Excel o PDF) y también
                        garantizar el acceso a información más completa”.
                      </td>
                    </tr>
                    <tr>
                      <td>6. Datos abiertos.</td>
                      <td>
                        Se propuso a la ONPE incluir la opción de descarga de
                        las bases de datos en formato Excel u otros, sobre la
                        información de los ingresos y gastos de los candidatos,
                        con el fin de que el periodismo pueda procesar la
                        información con mayor celeridad e incluso para poder
                        cruzar la información con otras bases de datos.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h4>2.1.3 PERIODISMO Y POLÍTICA</h4>
              <h5>A. Ciclo de Diálogos Políticos con Periodistas</h5>
              <p>En paralelo con el ciclo de capacitaciones, en marzo del 2022 iniciamos una ronda de sesiones virtuales de reflexión sobre temas políticos coyunturales. Fue así como surgió el Ciclo de Diálogos Políticos con Periodistas; un formato de sesiones virtuales libres que permiten analizar con mayor profundidad los temas controversiales que se debaten principalmente en el Congreso. Este formato se ha mantenido en el año 2023 y en el 2024 dimos inicio a jornadas de este tipo, pero para generar espacios de política comparada, en relación a situaciones y problemas que ponen en riesgo al sistema democrático en América Latina. Una primera sesión de intercambio se tuvo con colegas de Guatemala, para analizar el accionar de un sector político que pretendió evitar la asunción constitucional del nuevo presidente.</p>
             
              <h5>B. Curso con acreditación académica</h5>

              <p>Todo la experiencia previa reseñada nos permitió dar un importante paso para los años siguientes: la creación de un curso de alta especialización con acreditación académica universitaria sobre Periodismo y Política. Esta iniciativa fue posible gracias al compromiso en conjunto de nuestra organización, la Pontificia Universidad Católica del Perú e IDEA Internacional. El curso se ejecutó por primera vez en el 2022 y tuvo continuidad en el 2023. En ambos años logramos otorgar becas a un total de 126 periodistas de todo el Perú, para ser capacitados por docentes nacionales e internacionales, con las exigencias académicas que demanda un curso de esta naturaleza. Las sesiones contemplan aspectos teóricos sobre democracia, procesos constitucionales, sistema de partidos, reformas electorales, fiscalización al Congreso y políticas públicas, y también se ha previsto sesiones prácticas sobre herramientas digitales para la investigación. La intervención incluye la publicación de informes periodísticos finales como requisito para acceder a la certificación final.</p>
              
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={FotoGrupalPucp}
                  alt="Periodistas de todo el Perú tuvieron una capacitación sobre política e innovación digital en el campus de la PUCP en Lima."
                  className=""
                />
                <div className="legend">
                Periodistas de todo el Perú tuvieron una capacitación sobre política e innovación digital en el campus de la PUCP en Lima.
                </div>
              </figure>

              <p>En el 2023, un grupo de 29 participantes que evidenciaron un mejor rendimiento en la segunda edición del curso fueron invitados para participar en un taller presencial de dos días, en el campus de la Pontificia Universidad Católica del Perú en Lima. Esta iniciativa ha sido posible gracias a la voluntad y determinación para la suma de esfuerzos por parte de las autoridades de la Facultad de Ciencias y Artes de la Comunicación, el Departamento Académico de Comunicaciones, la Escuela de Gobierno y el rectorado de la Pontificia Universidad Católica del Perú y también por el valioso apoyo y compromiso de la organización IDEA Internacional.</p>

              <div className="row-content img-center group-fotos-talleres">
              <figure className="img-col-1 ">
                <img
                  src={FotoPucp1}
                  alt="Taller presencial en Lima"
                  className=""
                />
              
              </figure>
              <figure className="img-col-1">
                <img
                  src={FotoPucp2}
                  alt="Taller presencial en Lima"
                  className=""
                />
             <div className="legend">
                El taller presencial en Lima incluyó jornadas prácticas de producción de contenidos desde las herramientas digitales, incluyendo la inteligencia artificial.
                </div>
              </figure>
              </div>
             
              
              
              <h5>C. Periodismo político e igualdad de género</h5>
              <p>Entre los años 2023 y 2024, la Fundación Gustavo Mohme Llona dio inicio a una intervención más directa de trabajo con periodistas mujeres del sur, para fortalecer sus capacidades en la cobertura de temas políticos. Esta decisión fue adoptada en el contexto de los altos niveles de conflictividad social y la necesidad de tender puentes de diálogo en la macrorregión sur. También se tomó en cuenta el análisis interno realizado por nuestra organización sobre la muy baja participación política de las mujeres en cargos ejecutivos de la gobernación regional y las alcaldías provinciales y distritales, situación que esperamos ayudar a revertir progresivamente, en alianza con las periodistas de las regiones del sur. Para materializar esta intervención, fuimos convocados por IDEA Internacional, a fin de formar de Perú Conversa, un proyecto impulsado en 17 regiones del Perú con el propósito de promover los valores democráticos y el diálogo político.</p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={FotoGrupalMicaelas}
                  alt="Red de Periodistas Políticas Mujeres del Sur del Perú"
                  className=""
                />
                <div className="legend">
                El 2 de marzo del 2024 se constituyó en Cusco la nueva Red de Periodistas Políticas Mujeres del Sur del Perú: Micaelas.
                </div>
              </figure>
              <p>En el 2023 realizamos un curso virtual sobre “Nuevas Herramientas y Formatos para la Cobertura Política”, con participación de 40 periodistas mujeres. Luego, en el 2024, realizamos un taller presencial en Cusco, con la participación de 18 periodistas mujeres de las regiones de Cusco, Ayacucho, Apurímac, Puno y Arequipa.</p>
              <figure className="img-right img-m">
                <div className="block-blue-light"></div>
                <img
                  src={LogoMicaelas}
                  alt="Logo"
                  className="img-m border-img"
                />
                <div className="legend">
                Logotipo de Micaelas.
                </div>
              </figure>
              <p>La jornada concluyó con la conformación de la nueva Red de Periodistas Políticas Mujeres del Sur del Perú – Micaelas, organización cuyo objetivo es contribuir con el fortalecimiento de la igualdad en la participación política y dinamizar el debate y la atención de los problemas que atañen a las mujeres en la macrorregión sur del Perú.</p>
             
              <p>Con ocasión del 8 de marzo, en el Día Internacional de la Mujer, esta red estrenó el sitio web micaelas.pe, con el apoyo directo de nuestra organización.El trabajo que realiza nuestra organización con esta nueva red, en el marco del proyecto Perú Conversa, contempla la producción de programas políticos radiales en las cinco regiones mencionadas, las mismas que son conducidas por integrantes de la red y buscan dinamizar el diálogo con una mayor participación de lideresas y distintas actoras sociales y políticas del sur del país.</p>
              <figure className="img-center">
                <img
                  src={SitioWebMicaelas}
                  alt="Captura de pantalla micaelas.pe"
                  className="border-img"
                />
                <div className="legend">
                El sitio web micaelas.pe busca dar mayor visibilidad a las mujeres en el debate político y público.
                </div>
              </figure>
              <figure className="img-center">
                <img
                  src={VocesDelSur}
                  alt="Voces del Sur"
                  className="border-img"
                />
                <div className="legend">
                Voces del Sur es la segunda iniciativa de la Red Micaelas. Un programa político de radio que se transmite en cinco regiones del sur.
                </div>
              </figure>
              <h4>
                2.1.4 DERECHOS HUMANOS: MOVILIZACIÓN HUMANA EN AMÉRICA LATINA
              </h4>
              <p>
                La Fundación Gustavo Mohme Llona tiene entre sus convicciones la
                defensa firme de los derechos humanos. Y todo sistema
                democrático debe garantizar la vigencia de los derechos
                fundamentales y el respeto a la dignidad de todas las personas.
                Como producto de la crisis humanitaria surgida en Venezuela,
                Perú ha sido uno de los países con mayor concentración de la
                migración. Al año 2019, Naciones Unidas estimaba en 782 169 el
                número de personas migrantes que residían en territorio peruano.
                En este contexto, desde la sociedad e incluso desde el mismo
                Estado, fueron surgiendo manifestaciones y decisiones políticas 
                de contenido discriminatorio.
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={TallerMovilizacion}
                  alt="Taller sobre movilización humana"
                  className=""
                />
                <div className="legend">
                  Taller sobre movilización humana en alianza con Amnistía
                  Internacional y la Agencia de la ONU para los Refugiados
                  (ACNUR).
                </div>
              </figure>
              <p>
                Esto llevó a la organización Amnistía Internacional a establecer
                una alianza con la Fundación Gustavo Mohme Llona para el
                desarrollo del taller "Técnicas y herramientas periodísticas
                para cubrir contextos de movilidad humana en América Latina:
                caso Venezuela", juntamente con la Agencia de la ONU para los
                Refugiados (ACNUR). El objetivo fue fortalecer las capacidades
                de los periodistas para la producción de contenidos
                informativos, éticos, libres de xenofobia y de estereotipos
                sobre las personas refugiadas y migrantes en Perú.
              </p>
              <div className="card">
                <div className="quote-blue">
                  <p>
                    Periodistas de Lima, Piura, Puno, Tacna, Tumbes, Callao,
                    Cusco, Apurímac y Arequipa fueron capacitados sobre los
                    derechos humanos en contextos de movilidad humana.
                  </p>
                </div>
                <div>
                  <img
                    src={JoeParkin}
                    alt="Joe Parkin"
                    className="img-responsive"
                  />
                </div>
              </div>
              <div className="card-legend">
                <div className="legend">
                  Periodista Joe Parkin Daniels, corresponsal de{" "}
                  <em>The Guardian</em>, comparte experiencias de cobertura en
                  América Latina.
                </div>
              </div>
              <p>
                La jornada se realizó los días 15, 16 y 17 de octubre del 2019
                en Lima. En concordancia con el sistema de trabajo de nuestra
                organización, se hizo una convocatoria pública de postulaciones
                y al final se seleccionó a 17 periodistas de Lima, Piura, Puno,
                Tacna, Tumbes, Callao, Cusco, Apurímac y Arequipa. En esta
                ocasión se priorizó a periodistas que laboraban en regiones
                fronterizas, donde se han identificado situaciones aún más
                críticas en relación con los migrantes. Asimismo, regiones donde
                se han presentado iniciativas, discursos o decisiones de
                autoridades subnacionales con un abierto contenido
                discriminatorio. Con posterioridad a esta jornada de
                capacitación, los periodistas realizaron publicaciones en sus
                respectivos medios de comunicación.
              </p>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img src={Anuska} alt="Anuska Buenaluque" className="" />
                <div className="legend">
                  Anuska Buenaluque durante charla organizada con Amnistía
                  Internacional.
                </div>
              </figure>
              <h4>2.1.5 PERIODISMO Y MEDIO AMBIENTE</h4>
              <p>
                Desde su creación, la Fundación Gustavo Mohme Llona ha trabajado
                bajo una estrategia de alianzas con otras organizaciones de la
                sociedad civil y entidades especializadas del Estado. En este
                marco, uno de los sectores donde también realiza importantes y
                sostenidas actividades con el trabajo periodístico es el medio
                ambiente. En distintas etapas y en función de temas más
                específicos, hasta el momento ha tenido como aliadas a las
                siguientes organizaciones: la Fundación Friedrich Ebert
                Stiftung; la Escuela de Periodismo de la Universidad Antonio
                Ruiz de Montoya; el Grupo Propuesta Ciudadana; la Sociedad
                Peruana de Derecho Ambiental (SPDA); y, más recientemente, la
                institución Fomento para la Vida (FOVIDA).
              </p>
              <h5>A. El periodismo y los conflictos socioambientales (2017)</h5>
              <p>
                Luego de los conflictos políticos de fines de la década de los
                noventa, distintos especialistas han alertado sobre el viraje de
                la conflictividad social en el Perú hacia el ámbito del sector
                extractivo.
              </p>
              <p>
                En el año 2017, los informes sobre conflictividad social de la
                Defensoría del Pueblo daban cuenta de 167 conflictos sociales,
                de los cuales 120 tenían directa vinculación con aspectos o
                controversias socioambientales. Es decir, el 71.9 %. La mayor
                parte de estos casos (98) suponía un nivel de atención desde el
                gobierno nacional, mientras que 21 conflictos tenían como centro
                de atención a las instancias de gobierno regional y municipal.
              </p>
              <p>
                Es en este contexto que, en alianza con la Fundación Friedrich
                Ebert Stiftung y la Escuela de Periodismo de la Universidad
                Antonio Ruiz de Montoya, organizamos tres talleres
                macrorregionales, bajo la modalidad semipresencial, sobre
                conflictos socioambientales e investigación periodística. Para
                tal fin, la universidad habilitó un aula virtual para un trabajo
                previo con los periodistas seleccionados. Posteriormente,
                realizamos talleres presenciales con especialistas en las
                ciudades de Arequipa, Huancayo y La Libertad:
              </p>
              <div className="table-content-talleres bg-blue-main table-propuestas">
                <table>
                  <thead>
                    <th>FECHA</th>
                    <th>TALLER</th>
                    <th>REGIONES</th>
                    <th>ASISTENTES</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Abril (virtual) 5 y 6 de mayo (presencial)</td>
                      <td>Macrosur</td>
                      <td>
                        Arequipa, Moquegua, Tacna, Cusco, Ica, Apurímac y Puno.
                      </td>
                      <td>22</td>
                    </tr>
                    <tr>
                      <td>Julio (virtual) 11 a 13 de agosto (presencial)</td>
                      <td>Macrocentro</td>
                      <td>Junín, Huancavelica, Ayacucho, Pasco y Huánuco.</td>
                      <td>25</td>
                    </tr>
                    <tr>
                      <td>
                        Octubre (virtual) 17 a 19 de noviembre (presencial)
                      </td>
                      <td>Macronorte</td>
                      <td>
                        Áncash, La Libertad, San Martín, Cajamarca, Lambayeque,
                        Amazonas, Piura y Tumbes.
                      </td>
                      <td>22</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card">
                <div className="quote-blue">
                  <p>
                    Un total de 69 periodistas fueron becados para los talleres
                    macrorregionales sobre conflictos socioambientales.
                  </p>
                </div>
                <div>
                  <img
                    src={TallerArequipa}
                    alt="Taller realizado en Arequipa"
                    className="img-responsive"
                  />
                </div>
              </div>
              <div className="card-legend">
                <div className="legend">Taller realizado en Arequipa.</div>
              </div>
              <p>
                Fueron en total 69 los periodistas capacitados para una mejor
                cobertura de los conflictos socioambientales. Las jornadas
                tuvieron un componente teórico de análisis sobre la
                conflictividad social en el país, información económica
                vinculada con el sector extractivo y revisión del marco
                normativo. Adicionalmente, se brindó asesoría personalizada
                sobre las propuestas de investigaciones periodísticas de cada
                participante.
              </p>
              <p>
                A partir de esta experiencia, desde la Fundación Gustavo Mohme
                Llona nos planteamos la necesidad de incluir en los proyectos de
                intervención, junto con los aliados, una etapa adicional de
                trabajo para el acompañamiento a los periodistas hasta la etapa
                final de la publicación de sus informes. Esto, asumiendo además
                otras estrategias como la incorporación de fondos especiales en
                el momento de planificación de las actividades, a efectos de que
                los periodistas puedan postular para acceder a un apoyo
                financiero que les permita contar con los recursos necesarios
                para el desarrollo de sus informes. Esto se fue implementando
                con éxito en las siguientes intervenciones.
              </p>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img
                  src={ElizabethSalazar}
                  alt="Elizabeth Salazar"
                  className=""
                />
                <div className="legend">
                  Elizabeth Salazar, de Ojo Público, comparte herramientas de
                  visualización de datos en el taller macrorregional del norte,
                  en Trujillo.
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img src={EpifanioBaca} alt="Epifanio Baca" className="" />
                <div className="legend">
                  Epifanio Baca, del Grupo Propuesta Ciudadana, participa como
                  expositor en el taller realizado en la ciudad de Arequipa.
                </div>
              </figure>
              <h5>B. Transparencia en las industrias extractivas</h5>
              <p>
                En el año 2020, el Grupo Propuesta Ciudadana estableció una
                alianza con nuestra organización para el desarrollo de un curso
                sobre transparencia en las industrias extractivas. Se trató de
                una intervención altamente especializada con un grupo compacto
                de 10 periodistas de las regiones de Arequipa, Apurímac, Cusco,
                Loreto, Piura y Moquegua, por ser el ámbito de intervención de
                la organización citada.
              </p>
              <figure className="img-right img-m">
                <div className="block-blue-light"></div>
                <img
                  src={WebExtractivas}
                  alt="Reportajes"
                  className="img-m border-img"
                />
                <div className="legend">
                  Los periodistas participantes en esta capacitación con el
                  Grupo Propuesta Ciudadana culminaron su trabajo con la
                  publicación de ocho reportajes de investigación que se pueden
                  leer en el siguiente enlace:
                  <a href="https://fundacionmohme.org/especiales/transparencia-industrias-extractivas/">
                    {" "}
                    https://fundacionmohme.org/especiales/transparencia-industrias-extractivas/
                  </a>
                </div>
              </figure>
              <p>
                Los participantes fueron seleccionados por invitación directa,
                previa evaluación de sus perfiles por parte de las
                organizaciones. Todos fueron capacitados en un taller virtual
                intensivo de seis sesiones sobre periodismo narrativo con el
                periodista argentino Roberto Herrscher. El reto era aplicar las
                herramientas del lenguaje narrativo para contar historias
                respecto a las comunidades y los aspectos socioeconómicos, en
                relación con las actividades extractivas. Los contenidos, al
                mismo tiempo, estuvieron orientados a dinamizar la cultura de la
                transparencia en el sector extractivo. Por ello, temas sobre el
                canon y sobrecanon; las ejecuciones presupuestales y la
                efectividad y eficiencia de las mismas; y posibles actos de
                corrupción y sospechas de elusión tributaria fueron materia de
                trabajo para los periodistas.
              </p>
              <p>
                El principal resultado de esta intervención es la producción de
                ocho reportajes especiales, con el acompañamiento periodístico
                del equipo de la Fundación Gustavo Mohme Llona, en El Búho
                (Arequipa), Cutivalú (Piura), Convoca (corresponsal de
                Arequipa), La Región (Loreto), Ojo Público (corresponsal de
                Cusco) y <em>La República</em>.
              </p>
              <p>
                Además de la publicación en sus respectivos medios, desde la
                Fundación Gustavo Mohme Llona habilitamos en nuestra web
                institucional un repositorio de estos ocho informes.
              </p>
              <div className="quote quote-center quote-blue">
                <p>
                  El periodismo puede contribuir al fortalecimiento de la
                  transparencia en las industrias extractivas.
                </p>
              </div>
              <figure className="img-center">
                <div className="block-blue"></div>
                <img src={TallerPC} alt="Taller" className="" />
                <div className="legend">
                  Jornada de capacitación con periodistas de Cusco y Apurímac,
                  con Juan José Ccoyllo del Grupo Propuesta Ciudadana.
                </div>
              </figure>
              <h5>
                C. Proyecto Infraestructura Natural para la Seguridad Hídrica
                (2018-2022)
              </h5>
              <p>
                Una institución aliada con la que establecimos mecanismos de
                intervención de manera más sostenida es la Sociedad Peruana de
                Derecho Ambiental (SPDA). Desde el 2018, cada año, hemos
                ejecutado junto con esta organización un curso nacional
                altamente especializado para periodistas, como parte del
                Proyecto Infraestructura Natural para la Seguridad Hídrica. Si
                bien el convenio para esta intervención fue suscrito con la
                SPDA, en la iniciativa participan también las organizaciones de
                sociedad civil Forest Trends, Condesan y EcoDecisión.
              </p>
              <p>
                Desde talleres presenciales en Arequipa y Piura, en los años
                2018 y 2019, hasta las jornadas en formato virtual por la
                pandemia, en los años 2020 y 2021, todas han sido experiencias
                muy enriquecedoras para los periodistas, quienes han ido
                incorporando a su agenda de trabajo materias relacionadas con la
                seguridad hídrica de sus regiones, tomando en cuenta la
                infraestructura natural con que cuentan (bofedales, zanjas de
                infiltración, prácticas de siembra y cosecha de agua, etc.).
              </p>
              <div className="quote quote-center quote-blue">
                <p>
                  En cuatro años, hemos capacitado a 133 periodistas de
                  distintas regiones con el Proyecto Infraestructura Natural
                  para la Seguridad Hídrica.
                </p>
              </div>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img src={TallerArequipa2018} alt="Taller" className="" />
                <div className="legend">
                  Visita a la comunidad Challhuanca, en Arequipa, durante el
                  primer taller del 2018.
                </div>
              </figure>
              <div className="table-content-talleres bg-blue-main table-propuestas">
                <table>
                  <thead>
                    <th>FECHA</th>
                    <th>SEDES</th>
                    <th>REGIONES</th>
                    <th>ASISTENTES</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2018</td>
                      <td>Arequipa</td>
                      <td>
                        San Martín, Piura, Junín, Lima, Arequipa, Cusco y
                        Moquegua
                      </td>
                      <td>18</td>
                    </tr>
                    <tr>
                      <td>2019</td>
                      <td>Piura</td>
                      <td>
                        San Martín, Piura, Junín, Lima, Arequipa, Cusco y
                        Moquegua
                      </td>
                      <td>18</td>
                    </tr>
                    <tr>
                      <td>2020</td>
                      <td>Formato virtual por la pandemia</td>
                      <td>
                        Arequipa, Lima, Callao, Cusco, Áncash, Piura, La
                        Libertad, Huánuco, San Martín, Junín, Puno, Ayacucho,
                        Moquegua, Ucayali y Apurímac
                      </td>
                      <td>47</td>
                    </tr>
                    <tr>
                      <td>2021</td>
                      <td>Formato virtual por la pandemia</td>
                      <td>
                        Ayacucho, Piura, Lima, Cusco, Puno, La Libertad,
                        Arequipa, Tacna, Pasco, Junín, Tumbes y Áncash
                      </td>
                      <td>50</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                En estos cuatro años, fueron 133 los periodistas capacitados en
                temas de infraestructura natural para la seguridad hídrica,
                procedentes de 15 regiones del país.
              </p>
              <p>
                Por tratarse de un tema técnico y novedoso en la agenda, y con
                el fin de garantizar una buena convocatoria en los procesos de
                postulaciones, la Fundación Gustavo Mohme Llona diseñó una
                estrategia y un marco temático que articule los temas técnicos
                sobre seguridad hídrica e infraestructura natural con aspectos
                periodísticos novedosos y de alto interés, como son los talleres
                prácticos de producción de pódcast, talleres de escritura
                narrativa o taller de SEO para periodistas.
              </p>
              <p>
                En ese marco, en el contexto de la pandemia, a través del
                formato virtual, logramos convocar a los siguientes expositores
                internacionales:
              </p>
              <ul>
                <li>El escritor Sergio Ramírez de Nicaragua</li>
                <li>La escritora argentina Leila Guerriero</li>
                <li>El escritor y periodista argentino Roberto Herrscher</li>
                <li>
                  El escritor y fundador de Radio Ambulante, Daniel Alarcón
                </li>
                <li>
                  El director de Anfibia Pódcast de Argentina, Tomás Pérez
                </li>
                <li>
                  La editora SEO del diario <em>El País</em> de España, Katy
                  Lema
                </li>
              </ul>
              <p>
                Finalmente, para esta intervención, el Proyecto Infraestructura
                Natural para la Seguridad Hídrica contempló un sistema de fondos
                de apoyo para los periodistas, a efectos de poder tener un
                financiamiento que viabilice el trabajo de cobertura y
                producción de los informes especializados.
              </p>
              <p>
                Parte de las publicaciones han sido incorporadas en repositorios
                implementados en la web de la fundación:
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={InfraestructuraNatural}
                  alt="Infraestructura Natural"
                  className=""
                />
                <div className="legend">
                  Especial de reportajes publicados en la web de La República
                  por periodistas de Lima y la macrorregión sur.{" "}
                  <a href="https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/">
                    https://fundacionmohme.org/especiales/infraestructura-natural-recuperar-fuentes-agua/
                  </a>
                </div>
              </figure>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={AguaInfraestructura}
                  alt="Infraestructura Natural"
                  className=""
                />
                <div className="legend">
                  Repositorio de informes especiales publicados en el 2020.{" "}
                  <a href="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/">
                    https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/
                  </a>
                </div>
              </figure>
              <p>
                Y en el 2021 se tuvo como una de las principales experiencias el
                acompañamiento a periodistas del grupo RPP para la producción de
                un pódcast de diez capítulos, bajo el título de “Cauces de
                vida”. El trabajo fue elaborado por las periodistas Giuliana
                Ramos (Lima), Maritza Sáenz (La Libertad), Ada Ramos (Junín),
                Deysi Rojas (Tumbes) y Rosario Romaní (Ayacucho).
              </p>
              <p>
                Asimismo, cuatro periodistas de <em>La República</em> de las
                regiones de Arequipa, Tacna, Piura y Callao elaboraron un
                especial de cuatro reportajes en formato cómic. Las cuatro
                historias desarrollan las luchas y vivencias de comunidades y
                familias, en relación con la seguridad hídrica en sus entornos y
                la apuesta por una mejor gestión de la infraestructura natural.
                Los periodistas participantes fueron Wilson Siancas (Piura), Liz
                Ferrer (Tacna), Alexis Roque (Arequipa) y Bernie Moreno
                (Callao).
              </p>
              <div className="row-content mb-1">
                <div className="col ">
                  <figure className="">
                    <img
                      src={HistoriasLucha}
                      alt="Historias de lucha"
                      className="img-responsive"
                    />
                    <div className="legend">
                      Especial multimedia de cuatro reportajes en formato cómic
                      para La República.
                      https://especiales.larepublica.pe/seguridad-hidrica-en-elperu-
                      historias-de-lucha-en-lima-arequipa-piura-y-tacna/
                    </div>
                  </figure>
                </div>
                <div className="col">
                  <figure className="">
                    <img
                      src={Cauces}
                      alt="Cauces de Vida"
                      className="img-responsive"
                    />
                    <div className="legend">
                      Especial con 10 pódcast sobre infraestructura natural con
                      periodistas de RPP.
                      https://audioplayer.pe/podcast/cauces-de-vida
                    </div>
                  </figure>
                </div>
              </div>
              <p>
                Tanto el especial de pódcast de RPP como la serie de informes en
                formato cómic de <em>La República</em> son proyectos que se
                concretaron como parte de un proceso de postulación a los fondos
                de apoyo económico del Proyecto Infraestructura Natural para la
                Seguridad Hídrica, una iniciativa que se ha replicado durante
                los cuatro años de intervención.
              </p>
              <div className="card">
                <div className="quote-blue">
                  <p>
                    Periodistas de distintas regiones han producido reportajes
                    en variados formatos sobre seguridad hídrica.
                  </p>
                </div>
                <div>
                  <img
                    src={ParticipantesSeguridad}
                    alt="Participantes"
                    className="img-responsive"
                  />
                </div>
              </div>
              <div className="card-legend">
                <div className="legend">
                  Participantes en el taller sobre seguridad hídrica realizado
                  en Piura.
                </div>
              </div>
              <h5>
                D. Cambio climático y género desde la perspectiva rural (2022)
              </h5>
              <p>
                Respecto al mismo eje temático en materia ambiental, la
                Fundación Gustavo Mohme Llona inició una alianza en el 2022 con
                la institución Fomento para la Vida (FOVIDA), para el desarrollo
                de un taller de capacitación virtual dirigido exclusivamente a
                periodistas de Lima, Huancavelica y Junín. El tema desarrollado
                fue “Programa de capacitación para periodistas sobre cambio
                climático y género en ámbitos urbanos y rurales”, y contó con la
                participación de 44 periodistas. También esta intervención
                contempla una etapa final de publicación de informes especiales
                sobre los temas desarrollados.
              </p>
              <h4>2.1.6 PERIODISMO DE INVESTIGACIÓN DESDE LAS UNIVERSIDADES</h4>
              <p>
                Un quinto espacio de intervención del Proyecto Talleres de
                Periodismo ha sido el trabajo con las escuelas o carreras de
                Periodismo o Ciencias de la Comunicación de las universidades
                públicas. Esto, a partir de la necesidad identificada de generar
                interés por parte de los estudiantes para el periodismo y, más
                en específico, el periodismo de investigación. En varios de los
                talleres realizados desde nuestra creación hemos reservado
                vacantes para estudiantes de los últimos ciclos interesados en
                el periodismo. Una grata respuesta fue la rápida adaptación de
                los estudiantes en los procesos de aprendizaje sobre el uso de
                las herramientas y plataformas virtuales y de datos abiertos
                para el trabajo de investigación.
              </p>
              <h5>A. Talleres de periodismo de investigación</h5>
              <p>
                A partir de la experiencia previa reseñada, desde la Fundación
                Gustavo Mohme Llona, impulsamos alianzas o convenios con
                universidades, con el fin de procurar un trabajo más sostenido.
                Esto lo hicimos específicamente con las siguientes casas de
                estudio:
              </p>
              <figure className="img-left img-m">
                <div className="block-blue-light"></div>
                <img
                  src={EstudiantesSanta}
                  alt="Estudiantes universitarios"
                  className="img-m"
                />
                <div className="legend">
                  Capacitación con estudiantes de la Universidad Nacional del
                  Santa en Áncash.
                </div>
              </figure>
              <ul>
                <li>Universidad Nacional de Ucayali</li>
                <li>Universidad Nacional del Santa (Áncash)</li>
                <li>Universidad Nacional de Piura</li>
                <li>Universidad Nacional San Antonio Abad del Cusco</li>
              </ul>
              <p>
                En el año 2019, realizamos talleres de periodismo de
                investigación dirigidos a los estudiantes de estas casas de
                estudio. Para tal fin convocamos a periodistas de importantes
                medios y programas de investigación, como una forma de generar
                un acercamiento, para que los estudiantes puedan interactuar
                directamente y conocer mejor el oficio del periodismo de
                investigación. Nos acompañaron periodistas del programa Cuarto
                Poder y los portales de investigación Ojo Público y Convoca.
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={TallerUniversidadUcayali}
                  alt="Edmundo Cruz y Daniel Yovera"
                  className=""
                />
                <div className="legend">
                  Edmundo Cruz y Daniel Yovera en un encuentro de capacitación
                  con estudiantes de la Universidad Nacional de Ucayali.
                </div>
              </figure>
              <h5>B. Incubadora de portales de investigación</h5>
              <p>
                En este marco de intervención, nuestra organización también dio
                los primeros pasos para el impulso de portales de investigación
                desde las mismas universidades. Esta iniciativa se vio
                interrumpida principalmente por la pandemia. No obstante, en el
                2019 se avanzó con actividades directas de investigación con
                participación de los estudiantes. El tema del seguimiento a la
                ejecución presupuestal de los municipios convocó a estudiantes
                voluntarios, principalmente de las universidades de Áncash y
                Ucayali, para el desarrollo de trabajos de investigación, lo
                cual generó informes que fueron compartidos en la edición
                impresa del diario <em>La República</em>. A esta iniciativa se
                sumó un grupo de estudiantes de la Universidad Nacional Mayor de
                San Marcos, quienes produjeron un informe sobre el ránking de
                ejecución presupuestal de los gobiernos locales de Lima
                Metropolitana. La información también fue difundida en el diario{" "}
                <em>La República</em>.
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={ReporterosNorte}
                  alt="Reporteros del Norte"
                  className=""
                />
                <div className="legend">
                  Parte de los avances y trabajos de investigación realizados
                  por estudiantes de la Universidad Nacional del Santa (Áncash)
                  fueron publicados en el portal Reporteros del Norte:
                  http://reporterosdelnorte.pe/
                </div>
              </figure>
              <h5>C. Herramientas virtuales: Vigila Perú</h5>
              <p>
                Con participación de los estudiantes universitarios, el proyecto
                de talleres sobre periodismo implementó, a modo de una primera
                experiencia, la plataforma denominada Vigila Perú, una
                herramienta interactiva para que la ciudadanía y los periodistas
                puedan conocer los avances y el ránking de ejecución
                presupuestal, al detalle por cada distrito del país.
              </p>
              <p>
                Acompañaron esta iniciativa estudiantes de periodismo y
                comunicación de la Universidad Nacional del Santa, la
                Universidad Nacional de Ucayali, la Universidad Nacional de San
                Antonio Abad del Cusco, la Universidad Nacional de Piura y la
                Universidad Nacional Mayor de San Marcos. Todos ellos fueron
                entrenados previamente en el uso de las plataformas del
                Ministerio de Economía y Finanzas para la visualización y
                descarga de la información a ser procesada.
              </p>
              <p>
                El trabajo con las universidades públicas busca generar también
                cambios institucionales, a través de la incorporación de más
                cursos sobre periodismo de investigación y periodismo de datos
                en las mallas curriculares, pues es un vacío que hemos podido
                identificar en esta intervención. Un avance auspicioso se dio en
                el 2022 en el caso de la Universidad Nacional de Ucayali, donde,
                a propósito de la renovación de la malla curricular, están
                incorporando específicamente el curso de Periodismo de
                Investigación, lo cual permitirá dar continuidad a futuras
                iniciativas de manera más sostenida.
              </p>
              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img src={WebVigilaPeru} alt="Vigila Peru" className="" />
                <div className="legend">
                  Herramienta digital de acceso público para conocer el ránking
                  de ejecución presupuestal en los distritos del Perú.
                  https://fundacionmohme.org/especiales/vigila-peru/
                </div>
              </figure>
              <div className="card">
                <div className="quote-blue">
                  <p>
                    La Fundación Gustavo Mohme Llona apuesta por el ejercicio
                    del periodismo de investigación desde las mismas
                    universidades.
                  </p>
                </div>
                <div>
                  <img
                    src={EstudiantesUcayali}
                    alt="Amado Enco"
                    className="img-responsive"
                  />
                </div>
              </div>
              <div className="card-legend">
                <div className="legend">
                  Estudiantes de la Universidad Nacional de Ucayali en trabajo
                  de campo.
                </div>
              </div>

              <figure className="img-center">
                <div className="block-blue-light"></div>
                <img
                  src={EstudiantesPiura}
                  alt="Estudiantes Piura"
                  className=""
                />
                <div className="legend">
                  Taller de capacitación en la Universidad Nacional de Piura,
                  con el periodista Ernesto Cabral.
                </div>
              </figure>
            </Fade>
          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/#periodismo"
            textPrev="2. Eje Periodismo y Democracia"
            next="https://fundacionmohme.org/especiales/memoria-2024/observatorio-universitario-medios"
            textNext="2.2 Observatorio Universitario de Medios"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Talleres;
